<div class="history-page">
  <h3 class="page-title">{{ 'Reservations History' | translate }}</h3>

  <div class="top-controls">
    <div class="year-picker">
      <p-dropdown
        [options]="years"
        [(ngModel)]="selectedYear"
        (onChange)="onYearChange()"
      ></p-dropdown>
    </div>

    <div class="view-toggle">
      <button
        class="toggle-btn"
        [class.toggle-btn--active]="activeView === 'chart'"
        (click)="activeView = 'chart'"
      >
        {{ 'Chart' | translate }}
      </button>
      <button
        class="toggle-btn"
        [class.toggle-btn--active]="activeView === 'list'"
        (click)="activeView = 'list'"
      >
        {{ 'List' | translate }}
      </button>
    </div>
  </div>

  @if (showVerifiedStatus && !verifiedLoading) {
    <div class="verified-summary">
      @if (verifiedCount > 0) {
        <span class="verified-pill verified-pill--ok">
          {{ 'Verified' | translate }}: {{ verifiedCount }}
        </span>
      }
      @if (unverifiedCount > 0) {
        <span class="verified-pill verified-pill--warn">
          {{ 'Unverified' | translate }}: {{ unverifiedCount }}
        </span>
      }
    </div>
  }

  @if (activeView === 'chart') {
    <app-reservation-history-chart
      [monthNames]="monthNames"
      [selectedYear]="selectedYear"
      [only_recurrings]="only_recurrings"
    ></app-reservation-history-chart>
  } @else {
    <div class="months-list">
      <cdk-accordion>
        @for (month of sortedMonths; track month.name) {
          <cdk-accordion-item
            #item="cdkAccordionItem"
            class="month-item"
            (expandedChange)="onAccordionExpanded($event, month.name)"
          >
            <button class="month-header" (click)="item.toggle()">
              <span class="month-name">
                {{ translateService.translateDays(month.name, 'MONTHS_SINGLE') }}
              </span>
              <span class="month-header-right">
                @if (showVerifiedStatus && isEligibleMonth(month.name)) {
                  @if (verifiedMonthMap[month.name]) {
                    <span class="verified-pill verified-pill--ok verified-pill--sm">
                      {{ 'Verified' | translate }}
                    </span>
                  } @else {
                    <span class="verified-pill verified-pill--warn verified-pill--sm">
                      {{ 'Unverified' | translate }}
                    </span>
                  }
                }
                @if (totalReservationsMap[month.name] !== undefined) {
                  <span class="month-count">{{ totalReservationsMap[month.name] }}</span>
                }
              </span>
            </button>

            @if (item.expanded) {
              <div class="month-body">
                @if (loading) {
                  <div class="month-loading">
                    <mat-spinner [diameter]="32"></mat-spinner>
                  </div>
                } @else if (emptyMonthMap[month.name]) {
                  <p class="empty-msg">
                    {{ 'No reservations found for' | translate }}
                    {{ translateService.translateDays(month.name, 'MONTHS_SINGLE') }}
                  </p>
                } @else {
                  <div class="res-list">
                    @for (r of monthlyReservationData[month.name]; track $index) {
                      <div class="res-row">
                        <div class="res-datetime">
                          <span class="res-time">{{ formatTime(r.startDateAndTime!) }}</span>
                          <span class="res-date">{{ formatDateOnly(r.startDateAndTime!) }}</span>
                        </div>
                        <div class="res-info">
                          @if (r.bookedByAdminReason) {
                            <span class="res-reason">{{ r.bookedByAdminReason }}</span>
                          }
                          @if (!only_recurrings && r.bookedByName) {
                            <span class="res-booked-by">{{ r.bookedByName }}</span>
                          } @else if (!only_recurrings && !r.bookedByName) {
                            <span class="res-booked-by">{{ 'Admin' | translate }}</span>
                          }
                        </div>
                      </div>
                    }
                  </div>

                  <div class="month-totals">
                    @if (!only_recurrings) {
                      <div class="total-row">
                        <span>{{ 'Total Reservations' | translate }}</span>
                        <strong>{{ totalBookings[month.name] || 0 }}</strong>
                      </div>
                    }
                    <div class="total-row">
                      <span>{{ 'Total recurring bookings' | translate }}</span>
                      <strong>{{ totalRecReservations[month.name] || 0 }}</strong>
                    </div>
                  </div>
                }
              </div>
            }
          </cdk-accordion-item>
        }
      </cdk-accordion>
    </div>
  }
</div>
